module.exports = __webpack_public_path__ + "img/logo.2395f42e.jpg";